import { endOfMonth, startOfMonth } from 'date-fns';
import { previousMonth } from 'utils/date';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

interface Invoice {
    accountId: number;
    advertisingServiceType: string;
    amount: number;
    discountAmount: number;
    bonusClicks: number;
    clicks: number;
    createdAt: string;
    employerId: number;
    invoiceId: number;
    number: number;
    userId: number;
}

// ----------------------- actions -------------------------------------
const SET_INVOICES_BY_CHARGES = 'SET_INVOICES_BY_CHARGES';
const SET_IS_LOAD_INVOICES_BY_CHARGES = 'SET_IS_LOAD_INVOICES_BY_CHARGES';
const SET_DATES_INVOICES_BY_CHARGES = 'SET_DATES_INVOICES_BY_CHARGES';

interface PayloadTypes {
    [SET_INVOICES_BY_CHARGES]: Invoice[];
    [SET_IS_LOAD_INVOICES_BY_CHARGES]: IsLoad;
    [SET_DATES_INVOICES_BY_CHARGES]: { from: FromDate; to: ToDate };
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setInvoices = ActionCreator(SET_INVOICES_BY_CHARGES);
export const setLoadInvoices = ActionCreator(SET_IS_LOAD_INVOICES_BY_CHARGES);
export const setDates = ActionCreator(SET_DATES_INVOICES_BY_CHARGES);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface ManualChargesState {
    invoices: Invoice[];
    isLoad: IsLoad;
    from: FromDate;
    to: ToDate;
}

export const MANUAL_CHARGES_INITIAL_STATE: ManualChargesState = {
    invoices: [],
    isLoad: false,
    from: startOfMonth(previousMonth),
    to: endOfMonth(previousMonth),
};

export default createReducer<ManualChargesState, PayloadTypes>(MANUAL_CHARGES_INITIAL_STATE, {
    [SET_INVOICES_BY_CHARGES]: (state, { payload }) => ({
        ...state,
        invoices: payload,
    }),
    [SET_DATES_INVOICES_BY_CHARGES]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_IS_LOAD_INVOICES_BY_CHARGES]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
